// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('categoryDatas', {
//         templateUrl: 'views/components/views/categoryDatas/categoryDatas.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'utilityService', 'categoryDatasService', 'layoutService', function ($stateParams, stateService, utilityService, categoryDatasService, layoutService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let argType = $stateParams.argtype;
//             let argValue = $stateParams.argvalue;

//             vm.model = {
//                 tabletSize: layoutService.getMediaQueries().tablet,
//                 bgCategoryDataSelection: {
//                     selected: 'A',
//                     buttons: [
//                         { id: 'A', label: 'categorydatas_all', color: 'primary', onClick: () => vm.model.bgCategoryDataSelection.selected = 'A' },
//                         { id: 'S', label: 'categorydatas_selected', color: 'primary', onClick: () => vm.model.bgCategoryDataSelection.selected = 'S' }
//                     ]
//                 },
//                 setting: {},
//                 selectListMainCategories: [],
//                 inputListCategoryDatas: [],
//                 lockedSave: false
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE CALL

//             async function loadSetting() {
//                 vm.model.setting = (await categoryDatasService.getSetting({
//                     argtype: argType,
//                     argvalue: argValue
//                 }))[0];
//             }

//             async function loadMainCategories() {
//                 if (utilityService.validateParmsValue(vm.model.setting.category_keyno_top) !== true) return;

//                 return vm.model.selectListMainCategories = await categoryDatasService.listMainCategories({
//                     category_keyno_top: vm.model.setting.category_keyno_top,
//                     argtype: argType,
//                     argvalue: argValue
//                 });
//             }

//             async function loadCategoryDatas() {
//                 if (utilityService.validateParmsValue(vm.model.setting.category_keyno_top) !== true) return;

//                 const list = await categoryDatasService.listCategoryDatas({
//                     argtype: argType,
//                     argvalue: argValue,
//                     category_keyno_top: vm.model.setting.category_keyno_top
//                 });

//                 for (let i = 0; i < list.length; i++) {
//                     validateCategoryDatas(list, i);
//                 }

//                 vm.model.inputListCategoryDatas = list;
//             }

//             // #endregion LOAD PROCEDURE CALL

//             // #region VALIDATE CATEGORY LIST

//             function validateCategoryDatas(list, index) {
//                 let itemValueNew = list[index].selected;
//                 let categoryKeyno = list[index].category_keyno;

//                 for (let i = index + 1; i < list.length; i++) {
//                     if (list[i].category_keyno_belongto === categoryKeyno) {
//                         list[i].visible = itemValueNew;
//                     }
//                 }
//             }

//             // #endregion VALIDATE CATEGORY LIST

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 categoryDatasService.saveObj({
//                     argtype: argType,
//                     argvalue: argValue,
//                     records: vm.model.inputListCategoryDatas.map(function (a) {
//                         return {
//                             "categorylink_keyno": a.categorylink_keyno,
//                             "category_keyno": a.category_keyno,
//                             "category_name": a.category_name,
//                             "selected": a.selected,
//                             "rectype": a.rectype
//                         };
//                     })
//                 }).then(() => {
//                     vm.model.lockedSave = false;
//                     stateService.back();
//                 }, () => vm.model.lockedSave = false);
//             }

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region BUTTON RADIO FUNCTIONS

//             vm.selectBgCategoryDataSelection = function (value) {
//                 vm.model.bgCategoryDataSelection.selected = value;
//             }

//             // #endregion BUTTON RADIO FUNCTIONS

//             // #region FIELD CHANGE MULTI FUNCTIONS

//             vm.onChanged = function (value, id) {
//                 switch (id) {
//                     case 'category_keyno_top':
//                         if (utilityService.validateWatchValue(value, vm.model.setting.category_keyno_top) !== true) return;

//                         vm.model.setting.category_keyno_top = value;

//                         if (utilityService.validateParmsValue(vm.model.setting.category_keyno_top) !== true) return;

//                         loadCategoryDatas();
//                         break;
//                     default:
//                         utilityService.setValueToVariable(value);
//                         break;
//                 }
//             };

//             // #endregion FIELD CHANGE MULTI FUNCTIONS

//             // #region ANGULAR LIFECYCLE

//             vm.$onInit = async function () {
//                 await loadSetting();
//                 loadMainCategories();
//                 loadCategoryDatas();
//             }

//             // #endregion ANGULAR LIFECYCLE

//         }]
//     });
// })();
